/* eslint-disable react-hooks/exhaustive-deps */

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { withStyles } from '@material-ui/core';

import { Box, Button, Grid, Paper, Typography } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  GET_AUTH_DESTINATION_SERVICES_FAILURE,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE
} from 'modules/authorizations/store/types/destinationServiceTypes';
import {
  deleteAuthDestinationTripsRenter,
  getAuthDestinationServices,
  updateAuthDestinationServicesRenter,
  updateAuthDestinationTripsRenter
} from 'modules/authorizations/store/actions/destinationService.actions';
import {
  getAuthDateSummary,
  getAuthorizationSummary,
  setAuthId,
  setLoadingComplete
} from 'modules/authorizations/store/actions/authorizations.actions';
import { getBrokerAgents, getBrokerAgentsById } from 'modules/authorizations/store/actions/dataManagement.actions';
import { getAddress } from 'modules/authorizations/store/actions/authorizations.actions';

import { CreateVendorRelationshipList, formatTripAddress } from 'modules/authorizations/utils';
import { findPartnerName, partnerSearchInfo } from 'modules/common/partnerSearchInfo';
// import DestinationServicesStatusStepper from './destinationServicesStatusStepper.component';
import EditableCard from 'modules/common/editableCard.component';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';
import Hint from 'modules/common/hint.component';
import HouseHuntingTripCard from './houseHuntingTripSummary.component';
import { showToast } from 'modules/layout/layout.actions';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import RenterPreferencesCard from './renterPreferencesCard.component';
// import { setStatusTypes } from '../../utils';
import CreateTripCard from 'modules/common/createAuthTripModal.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import { GET_SERVICE_STATUS_DATES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';
import EstimatedDatesCard from './destinationServicesEstimatedDates.component';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  },
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
});

const HOME_FINDING_TRIP_CATEGORY_ID = 'c0041355-c75d-4a0c-b2a9-69baf891e0d5';

const createAddressName = address => (!address ? '' : [address.addressLineOne, address.city, address.state].filter(Boolean).join(', '));

const RenterServices = props => {
  const { authId, details, location, isReadOnly, addresses, emailTemplates, vendors, enumerations, clientInfo } = props;
  const safeEmailTemplates = Array.isArray(emailTemplates) ? emailTemplates : [];
  const safeVendors = Array.isArray(vendors) ? vendors : [];
  const vendorsPreferredVendorSorted = CreateVendorRelationshipList(safeVendors, clientInfo?.clientDetails?.clientVendorRelationships);
  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Renter') : []
  );
  console.log(clientInfo);
  const getStatuses = async () => {
    if (details?.serviceStatusDates) {
      await props.getServiceStatusDates(authId);
      setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Renter'));
    }
  };

  const validTemplates = safeEmailTemplates.filter(et => et.serviceId === SERVICE_IDS.DESTINATION_RENTER_SERVICE_ID);

  const fileServices = details?.services
    ? details.services.find(fs => fs.authorizationFileServiceTypeId === '1f0148df-2898-4d52-88f1-03f8ceafb74f')
    : [];

  const familyMembers = details?.familyMembers || [];
  const destinationInfo = details?.destinationServices || {};
  const renter = destinationInfo?.destinationRenterInfo || {};
  const renterInfo = renter?.renter || {};
  const renterVendor = renterInfo.vendorId ? safeVendors.find(v => v.vendorId === renterInfo.vendorId) : null;
  const renterId = renter?.renter?.renterServiceId ?? null;
  const renterTrips = destinationInfo.renterTrips || [];

  const addressOptions =
    details?.addresses && details?.addresses.length > 0
      ? details?.addresses.map(a => {
        const addressLabel = formatTripAddress(a, enumerations?.provinces, enumerations?.countries);
        return { ...a, id: a.addressId, title: addressLabel, description: addressLabel };
      })
      : [];
  // const countryOptions =
  //   props.enumerations && Array.isArray(enumerations.countries) ? props.enumerations.countries.filter(s => s.isActive) : [];
  // const provinceOptionsAll =
  //   enumerations && Array.isArray(enumerations.provinces) ? enumerations.provinces.filter(s => s.isActive) : [];

  const authCommentServiceTypes =
    enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
      ? enumerations.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
      ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const filteredRenterTrips = React.useMemo(
    () =>
      renterTrips.filter(
        t => t.tripCategoryId === HOME_FINDING_TRIP_CATEGORY_ID || t.tripCategoryId === 'c407ec7e-55bf-4768-bba8-1a0bf58208ed'
      ),
    [renterTrips]
  );

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);

  const isFailure = r => r?.type?.endsWith('_FAILURE');

  let destAddress =
    addresses && Array.isArray(addresses) ? addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5') : null;

  let renterStatus = 'Initiated';
  if (enumerations?.renterStatuses?.find(bs => bs.id === renterInfo.renterStatusId)) {
    const renterStatusTitle = enumerations.renterStatuses.find(bs => bs.id === renterInfo.renterStatusId).title;
    if (renterStatusTitle && renterStatusTitle.length > 0) {
      renterStatus = renterStatusTitle;
    }
  }

  const [isLoading, setIsLoading] = useState(false);
  const [currentTripId, setCurrentTripId] = useState(filteredRenterTrips[0]?.tripId ?? null);
  const trip = filteredRenterTrips.find(t => t.tripId === currentTripId) ?? null;

  useEffect(() => {
    setCurrentTripId(filteredRenterTrips[0]?.tripId ?? null);
  }, [filteredRenterTrips]);

  const [currentStatus, setCurrentStatus] = useState(renterStatus);

  useEffect(() => {
    //setCurrentStatus(props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)?.title ?? 'Initiated');
    getStatuses();
  }, [renter?.renter.renterStatusId]);

  const createTrip = async values => {
    setIsLoading(true);

    let newValues = {};

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = values.tripCategoryId ? values.tripCategoryId : HOME_FINDING_TRIP_CATEGORY_ID;
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    newValues.tripStartDate = values.tripStartDate ? values.tripStartDate : new Date();
    newValues.tripEndDate = values.tripEndDate ? values.tripEndDate : new Date();
    newValues.departureDate = values.departureDate ? values.departureDate : new Date();
    newValues.arrivalDate = values.arrivalDate ? values.arrivalDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    const resp = await props.updateAuthDestinationTripsRenter(renter?.renter.renterServiceId, newValues);

    if (isFailure(resp)) {
      props.showToast('Failed to create the house hunting trip. Please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return;
    }

    const destInfo = await props.getAuthDestinationServices(authId);
    if (isFailure(destInfo)) {
      props.showToast('Trip created, but failed to refresh trips.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return;
    }

    const ds = destInfo?.response?.destinationServices;
    const newList = (ds?.renterTrips || []).filter(
      t => t.tripCategoryId === HOME_FINDING_TRIP_CATEGORY_ID || t.tripCategoryId === 'c407ec7e-55bf-4768-bba8-1a0bf58208ed'
    );

    const newId = resp?.response?.tripId ?? newList.slice(-1)[0]?.tripId;
    if (newId) setCurrentTripId(newId);

    props.showToast('New House Hunting Trip created successfully.', { userMustDismiss: false, severity: 'success' });
    setIsLoading(false);
  };

  const deleteTrip = async () => {
    if (!currentTripId) return;

    const resp = await props.deleteAuthDestinationTripsRenter(currentTripId);

    if (isFailure(resp)) {
      props.showToast('Failed to delete the trip, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    props.showToast('Trip deleted successfully.', { userMustDismiss: false, severity: 'success' });

    const destInfo = await props.getAuthDestinationServices(authId);
    if (isFailure(destInfo)) return;

    const ds = destInfo?.response?.destinationServices;
    const refreshedTrips = (ds?.renterTrips || []).filter(
      t => t.tripCategoryId === HOME_FINDING_TRIP_CATEGORY_ID || t.tripCategoryId === 'c407ec7e-55bf-4768-bba8-1a0bf58208ed'
    );

    setCurrentTripId(refreshedTrips[0]?.tripId ?? null);
  };

  // The broker is a partner (vendor): vendorId points at a Vendor.Record, or is null.
  const brokerPartnerSearchInfo = partnerSearchInfo(safeVendors);

  // const brokerAgentSearchInfo = {
  //   searchingColumns: [
  //     { name: 'agentId', title: 'Id' },
  //     { name: 'agentTypeIdReadable', title: 'Type of Agent' },
  //     { name: 'firstName', title: 'First Name' },
  //     { name: 'lastName', title: 'Last Name' },
  //     { name: 'companyName', title: 'Company Name' },
  //     { name: 'citiesServed', title: 'City' }
  //   ],
  //   searchingColumnExtensions: [
  //     { name: 'agentId', width: 100 },
  //     { columnName: 'agentTypeIdReadable', width: 150 },
  //     { columnName: 'firstName', width: 200 },
  //     { columnName: 'lastName', width: 200 },
  //     { columnName: 'companyName', width: 300 },
  //     { columnName: 'citiesServed', width: 150 }
  //   ],
  //   searchingRows: (brokerAgents || []).map(agent => ({
  //     ...agent,
  //     agentTypeIdReadable: enumerations?.agentTypes?.find(type => type.id === agent.agentTypeId)?.title ?? ''
  //   })),
  //   nameKey: 'agentName',
  //   idKey: 'agentId'
  // };

  const mainCardTabs = [{ header: 'Vendor Info', order: 1, iconPath: ['fas', 'fa-truck-moving'] }];

  const mainCardRenterSummaries = [
    {
      header: 'Broker/Agent',
      accessorKey: 'vendorId',
      nameKey: 'agentName',
      nameValue: findPartnerName(safeVendors, renterInfo.vendorId),
      type: 'advanced-search',
      searchInfo: brokerPartnerSearchInfo,
      value: renterInfo.vendorId || 0,
      tab: 1
    },
    {
      header: 'Agent Email',
      type: 'text',
      value: renterVendor?.officeEmail ?? '',
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Agent Phone',
      type: 'text',
      value: renterVendor?.officePhone ?? '',
      tab: 1,
      hideInModal: true
    },
    { header: 'New Address', type: 'text', value: createAddressName(destAddress), tab: 1, hideInModal: true }
  ];

  const onCancelService = async () => {
    setCurrentStatus('Canceled');
    let newVals = { ...renter };

    newVals.renter = newVals.renter || {};
    newVals.areaTourInfo = newVals.areaTourInfo || {};

    // Same fields regardless of renter or buyer
    newVals.renter.serviceInitiationDate = renter?.renter?.serviceInitiationDate ?? fileServices.addedOn;
    newVals.renter.serviceCanceledDate = new Date().toISOString();
    newVals.renter.serviceCompletionDate = null;
    newVals.renter.serviceOnHoldDate = null;
    newVals.renter.authorizationId = authId;
    newVals.renter.renterStatusId = props.enumerations.renterStatuses.find(s => s.title === 'Canceled')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesRenter(authId, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(authId);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Renter'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const onCompleteService = async () => {
    setCurrentStatus('Completed');
    let newVals = { ...renter };

    newVals.renter = newVals.renter || {};
    newVals.areaTourInfo = newVals.areaTourInfo || {};

    // Same fields regardless of renter or buyer
    newVals.renter.serviceInitiationDate = renter?.renter?.serviceInitiationDate ?? fileServices.addedOn;
    newVals.renter.serviceCompletionDate = newVals.renter.serviceCompletionDate == null ? new Date().toISOString() : null;
    newVals.renter.serviceCanceledDate = null;
    newVals.renter.serviceOnHoldDate = null;
    newVals.renter.renterStatusId = props.enumerations.renterStatuses.find(s => s.title === 'Completed')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesRenter(authId, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(authId);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Renter'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const onSetOnHold = async () => {
    setCurrentStatus('On Hold');
    let newVals = { ...renter };

    newVals.renter = newVals.renter || {};
    newVals.areaTourInfo = newVals.areaTourInfo || {};

    // Same fields regardless of renter or buyer
    newVals.renter.serviceInitiationDate = renter?.renter?.serviceInitiationDate ?? fileServices.addedOn;
    newVals.renter.serviceOnHoldDate = new Date().toISOString();
    newVals.renter.serviceCompletionDate = null;
    newVals.renter.serviceCanceledDate = null;
    newVals.renter.renterStatusId = enumerations.renterStatuses.find(s => s.title === 'On Hold')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesRenter(authId, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(authId);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Renter'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const takeOffHold = async () => {
    setCurrentStatus('Active');
    let newVals = { ...renter };

    newVals.renter = newVals.renter || {};
    newVals.areaTourInfo = newVals.areaTourInfo || {};

    // Same fields regardless of renter or buyer
    newVals.renter.serviceInitiationDate = renter?.renter?.serviceInitiationDate ?? fileServices.addedOn;
    newVals.renter.serviceOnHoldDate = null;
    newVals.renter.serviceCompletionDate = null;
    newVals.renter.serviceCanceledDate = null;
    newVals.renter.renterStatusId = props.enumerations.renterStatuses.find(s => s.title === 'Initiated')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesRenter(authId, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(authId);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Renter'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const updateRenterFields = async (tab, values) => {
    setIsLoading(true);

    const payload = { ...(renter || {}) };

    payload.renter = payload.renter || {};
    payload.areaTourInfo = payload.areaTourInfo || {};

    payload.renter.serviceInitiationDate = renter?.renter?.serviceInitiationDate ?? fileServices.addedOn;
    payload.renter.renterServiceId = renter?.renter?.renterServiceId ?? 0;
    payload.renter.authorizationFileId = authId;
    payload.renter.vendorId = values.vendorId || null; // 0 means no broker was picked; the column is a nullable FK to Vendor.Record
    payload.renter.serviceStatusId = currentStatus;
    payload.renter.serviceInitiationDate = values.serviceInitiationDate ?? null;
    payload.renter.serviceCanceledDate = values.serviceCanceledDate ?? null;
    payload.renter.serviceOnHoldDate = values.serviceOnHoldDate ?? null;
    payload.renter.completedDate = values.serviceCompletedDate ?? null;
    payload.renter.addedOn = renter ? renter.addedOn : new Date();
    payload.renter.addedBy = 0;
    payload.renter.modifiedOn = new Date();
    payload.renter.modifiedBy = 0;

    payload.areaTourInfo.areaTourId = values.requestAreaTour ? renter?.areaTourId : null;
    payload.areaTourInfo.areaTourInitiationDate = values.requestAreaTour ? values.areaTourInitiationDate : null;
    payload.areaTourInfo.areaTourCanceledDate = values.requestAreaTour ? values.areaTourCanceledDate : null;
    payload.areaTourInfo.areaTourCompletedDate = values.requestAreaTour ? values.areaTourCompletedDate : null;
    payload.areaTourInfo.areaTourAgentId = values.requestAreaTour ? values.areaTourAgentId : 0;
    payload.areaTourInfo.addedOn = renter && renter.areaTourInfo ? renter.areaTourInfo.addedOn : new Date();
    payload.areaTourInfo.addedBy = 0;
    payload.areaTourInfo.modifiedOn = new Date();
    payload.areaTourInfo.modifiedBy = 0;

    const resp = await props.updateAuthDestinationServicesRenter(authId, payload);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_RENTER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getAuthDestinationServices(authId);
      if (getResp.type === GET_AUTH_DESTINATION_SERVICES_FAILURE) {
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const vendorOptions = React.useMemo(() => {
    const destServices = details?.destinationServices;

    const renterVendorId = destServices?.destinationRenterInfo?.renter?.vendorId;

    const vendorIdSet = new Set([renterVendorId]);
    const options = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (vendorsPreferredVendorSorted || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);

    return options;
  }, [details, vendorsPreferredVendorSorted]);

  const [openStatusMenu, setOpenStatusMenu] = useState(false);
  const renterStatusOrder = [
    {
      title: 'Initiated',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'Initiated')?.id
          : '',
      isActive: true,
      date: renter?.renter?.serviceInitiationDate ?? null
    },
    {
      title: 'Active Rental Search',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'Active Rental Search')?.id
          : '',
      isActive: true,
      date: renter?.renter?.activeRentalSearchDate ?? null
    },
    {
      title: 'Rental Secured',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'Rental Secured')?.id
          : '',
      isActive: true,
      date: renter?.renter?.rentalSecuredDate ?? null
    },
    {
      title: 'Canceled',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'Canceled')?.id
          : '',
      isActive: renterStatus === 'Canceled' ? true : false,
      date: renter?.renter?.serviceCanceledDate ?? null
    },
    {
      title: 'On Hold',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'On Hold')?.id
          : '',
      isActive: renterStatus === 'On Hold' ? true : false,
      date: renter?.renter?.serviceOnHoldDate ?? null
    },
    {
      title: 'Completed',
      id:
        enumerations && enumerations.renterStatuses && enumerations.renterStatuses.length > 0
          ? enumerations.renterStatuses.find(s => s.title === 'Completed')?.id
          : '',
      isActive: renterStatus === 'Completed' ? true : false,
      date: renter?.renter?.serviceCompletedDate ?? null
    }
  ];

  return (
    <>
      <Box sx={{ padding: '20px' }}>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Paper
            square
            className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}
            sx={{
              position: 'sticky',
              paddingRight: '10px',
              paddingLeft: '10px',
              marginBottom: '15px',
              minWidth: '100%'
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px', marginBottom: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <div></div>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                <StatusMenu
                  anchorEl={openStatusMenu}
                  onClose={() => setOpenStatusMenu(false)}
                  currentStatus={currentStatus}
                  statusHeader="Renter Status"
                  statusList={renterStatusOrder}
                  statusDates={statuses}
                  classes={props.classes}
                  serviceInitiatedDate={renter?.renter?.serviceInitiationDate}
                />
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Move Type
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {enumerations?.moveTypes?.find(mt => mt.id === details?.authorizationDetails?.moveTypeId)?.title}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Policy
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {clientInfo?.clientDetails?.clientRelocationPolicies?.find(cp => cp.policy.relocationPolicyId === details?.authorizationDetails?.relocationPolicyId)?.policy.policyCode}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {location && !location.pathname.includes('expenses') && !isReadOnly && (
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#868686',
                      '&:hover': { backgroundColor: '#474747' }
                    }}
                    onClick={onCancelService}
                  >
                    {' '}
                    Cancel Service{' '}
                  </Button>
                  { !renter.renter.serviceOnHoldDate && (
                    <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#f0b11d',
                      '&:hover': { backgroundColor: '#ba8a00' }
                    }}
                    onClick={onSetOnHold}
                  >
                    {' '}
                    Set On Hold{' '}
                  </Button>
                  )}
                  { renter.renter.serviceOnHoldDate && (
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{
                        maxHeight: '40px',
                        marginLeft: '12px',
                        marginTop: '8px',
                        backgroundColor: '#868686',
                        '&:hover': { backgroundColor: '#474747' }
                      }}
                      onClick={takeOffHold}
                    >
                      Take Off Hold
                    </Button>
                  )}
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onClick={onCompleteService}
                  >
                    {' '}
                    Complete Service{' '}
                  </Button>
                  <Button
                    onClick={() => setShowComment(true)}
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#41B7C0',
                      color: 'white',
                      '&:hover': { backgroundColor: '#3d959c' }
                    }}
                  >
                    Comments
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
        {/* <DestinationServicesStatusStepper status={currentStatus} allStatuses={setStatusTypes('Renter', currentStatus)} /> */}
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} xl={8} rowSpacing={2}>
            <RenterPreferencesCard
              authId={authId}
              renterDetails={renter}
              fileServices={fileServices}
              currentStatus={currentStatus}
              hideEdit={location.pathname.includes('expenses') || isReadOnly}
              enumerations={enumerations}
              authCommentRegardingTypes={authCommentRegardingTypes}
              authCommentServiceTypes={authCommentServiceTypes}
              emailTemplates={safeEmailTemplates}
              vendors={vendorsPreferredVendorSorted}
              allVendors={safeVendors}
              setStatusDates={getStatuses}
            />
            <Grid item sx={{ marginBottom: '10px', marginTop: '16px' }}>
              <CreateTripCard
                onSubmit={createTrip}
                onDelete={deleteTrip}
                familyMembers={details?.familyMembers}
                trips={renterTrips || []}
                location={location}
                enumerations={props.enumerations}
                addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                showToast={showToast}
                classes={props.classes}
                currentTripId={currentTripId}
                setCurrentTripId={setCurrentTripId}
                isReadOnly={location.pathname.includes('expenses') || isReadOnly}
              />
            </Grid>

            {currentTripId && (
              <>
                <Grid item>
                  <HouseHuntingTripCard
                    trip={trip}
                    familyMembers={familyMembers}
                    travelRequests={(renterTrips || []).filter(
                      t => t.tripCategoryId === HOME_FINDING_TRIP_CATEGORY_ID || t.tripCategoryId === 'c407ec7e-55bf-4768-bba8-1a0bf58208ed'
                    )}
                    hideEdit={location.pathname.includes('expenses') || isReadOnly}
                    id={authId}
                    addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                    enumerations={enumerations}
                    renter={renter}
                    serviceId={renter?.renter?.renterServiceId}
                    type={'Renter'}
                  />
                </Grid>
              </>
            )}
          </Grid>
          <Grid item xs={12} xl={4} rowSpacing={2}>
            <Box>
              <AuthServiceGlobalEmailCardComponent
                authId={authId}
                communication={details.authorizationDetails}
                emailTemplates={safeEmailTemplates}
                serviceId={SERVICE_IDS.DESTINATION_RENTER_SERVICE_ID}
                authCommentServicesEnum={authCommentServiceTypes}
                authCommentRegardingEnum={authCommentRegardingTypes}
                authSentTemplates={details.sentEmailTemplates}
                history={props.history}
                selectedAuthServiceId={renterId}
                vendorOptions={vendorOptions}
                allVendorOptions={vendorsPreferredVendorSorted}
                serviceTemplates={validTemplates}
                selectedSegmentServiceId={renterId}
              />
            </Box>
            <Box sx={{ marginTop: '16px' }}>
              <EditableCard
                tabs={mainCardTabs}
                summaries={mainCardRenterSummaries}
                numColumns={2}
                updateFields={updateRenterFields}
                isLoading={isLoading}
                hideEdit={location.pathname.includes('expenses') || isReadOnly}
                ButtonComponent={() => (
                  <Box sx={{ paddingTop: '20px' }}>
                    <Hint>The recommended rental vendor in most cases is Porchlight.</Hint>
                  </Box>
                )}
              />
            </Box>
            <Box sx={{ marginTop: '16px' }}>
              <EstimatedDatesCard estimatedDates={destinationInfo.destinationEstimatedDates} hideEdit={location.pathname.includes('expenses') || isReadOnly} authId={authId} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={authId}
          serviceOptionId={'946f7f77-2a35-4d86-9b18-616f927f7124'}
          displayText={'Destination Renter - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={authId}
          serviceOptionId={'946f7f77-2a35-4d86-9b18-616f927f7124'}
          setShowComment={setShowComment}
          isOpen={true}
        />
      )}
    </>
  );
};

RenterServices.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getAuthDateSummary,
    getAuthDestinationServices,
    getBrokerAgents,
    setAuthId,
    setLoadingComplete,
    getBrokerAgentsById,
    getAddress,
    showToast,
    updateAuthDestinationServicesRenter,
    updateAuthDestinationTripsRenter,
    deleteAuthDestinationTripsRenter,
    getServiceStatusDates
  })
)(RenterServices);
